import {useState,useEffect} from "react";
import {Link} from "react-router-dom";
import ImageWithBasePath from "../../core/img";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {all_routes} from "../router/all_routes";
import {Config,Field,Message,Title,Type,Url} from "../../constant";
// -- biz9 --
import {UrlQuery} from "biz9-react-utility";
import {Log} from "biz9-utility";
import {App,Data,Dashboard,Event,Field_Logic,Image,Style,Service_Industry,Template,Toast_Message,Storage,System,User} from "../../project";
import {Image_Format} from "biz9-image";
import {Data_Logic} from "biz9-data-app";
import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_CMS,Portal_Table,Portal_Remote_Image,Sub_Value_Type} from "biz9-portal-app";
import SubValue from "../subValue";
const Contact = () => {
    /* -- DEFINE --
     * --- Sub-ValueZ ---
     *  #3 - link,text
    */
    const query = UrlQuery();
     // -- edit-mode --
     const [sub_value_edit,setSubValueEdit] = useState(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,0));
     const [page,setPage] = useState(Data_Logic.get(Portal_Table.PAGE,0));
     const [sub_value_group,setSubValueGroup] = useState(Sub_Value_Logic.get_test_sub_value_group({count:50,show_value:false}));
     const [edit_mode,setEditMode] = useState(false);
       useEffect(() => {
        Toast_Message.loading(Message.LOADING);
        get_page_data();
    }, []);
    //
    /*
    useEffect(() => {
        Toast_Message.loading(Message.LOADING);
        get_items_data();
    }, []);
    */

    async function get_page_data() {
        // -- get-page-data --
        let option = {get_cache:false,time_limit:10};
        const [response,data] = await Portal_Remote_Page.get(App.get_url(Portal_Url.PAGE_GET),Portal_Page.CONTACT_HOME.title_url,option);
        Log.w('PAGE-DATA',data[Portal_Type.PAGE]);
        bind_page(data);
    };
    /*
    async function get_items_data() {
        // -- remote-data-response --
        let option = {get_cache:false,time_limit:10};
        const [response,data] = await Portal_Remote_Page.get_contact_home_items(App.get_url(Portal_Page.CONTACT_HOME[Portal_Type.ITEMS_URL]),option);
        bind_items(data);
        Toast_Message.dismiss();
    }
    */

       async function bind_page(data) {
        // -- page-template --
        setPage(data[Portal_Type.PAGE]);
        // -- page-edit --
        setEditMode(query.get('edit_mode'));
        setSubValueEdit(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,data[Portal_Type.PAGE].id));
        // -- sub-values --
        bind_sub_values(data[Portal_Type.SUB_VALUE_GROUP]);
    };
    async function bind_sub_values(data_sub_group) {
        // -- bind-sub-values --
        for(const sub_group in data_sub_group){
            if(data_sub_group[sub_group].type != Sub_Value_Type.ITEMS){
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].value = data_sub_group[sub_group].value;
            }else{
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].items = data_sub_group[sub_group].items;
            }
        }
        Storage.post_sub_value_group(sub_value_edit,data_sub_group);
    };
    async function update_sub_value(sub_value) {
        // -- page-edit-sub-values --
        if(sub_value.type != Sub_Value_Type.ITEMS){
            setSubValueGroup(sub_value_group => ({
                ...sub_value_group,
                    [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                    ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                    value: sub_value.value
                }
            }));
        }else{
            setSubValueGroup(sub_value_group => ({
                ...sub_value_group,
                    [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                    ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                    items: sub_value.items
                }
            }));
        }
    }
    return (
            <>
            {/* Breadcrumb */}
            <div className="breadcrumb-bar">
            <div className="breadcrumb-img">
            <div className="breadcrumb-left">
            <ImageWithBasePath src="/assets/img/bg/banner-bg-03.png" alt="img" />
            </div>
            </div>
            <div className="container">
            <div className="row">
            <div className="col-md-12 col-12">
            <nav aria-label="breadcrumb" className="page-breadcrumb">
            <ol className="breadcrumb">
            <li className="breadcrumb-item">
            <Link to={all_routes.home}>Home</Link>
            </li>
            <li className="breadcrumb-item" aria-current="page">
            Contact Us
            </li>
            </ol>
            </nav>
            <h2 className="breadcrumb-title">
        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,1):""}
        {sub_value_group.sub_value_1.value}
    </h2>
        </div>
        </div>
        </div>
        </div>
        {/* /Breadcrumb */}
    {/* Contact Us */}
    <section className="contact-section">
    {/* Contact Bottom */}
    <div className="contact-bottom bg-white">
        <div className="container">
        <div className="row justify-content-center">
        {/* Contact Grid */}
    <div className="col-lg-4 col-md-6 d-flex">
        <div className="contact-grid w-100">
        <div className="contact-content">
        <div className="contact-icon">
        <span>
        <ImageWithBasePath src="/assets/img/icons/contact-mail.svg" alt="Icon" />
        </span>
        </div>
        <div className="contact-details">
        <h6>
       {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,2):""}
        {sub_value_group.sub_value_2.value}
        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.ITEMS,3):""}
        </h6>
        {sub_value_group.sub_value_3.items.map((item) => (
           <p>
        <Link to={item.link}>
        {item.text}
    </Link>
        </p>
           ))}
        </div>
        </div>
        </div>
        </div>
        {/* /Contact Grid */}
    {/* Contact Grid */}
    <div className="col-lg-4 col-md-6 d-flex">
        <div className="contact-grid w-100">
        <div className="contact-content">
        <div className="contact-icon">
        <span>
        <ImageWithBasePath src="/assets/img/icons/contact-phone.svg" alt="Icon" />
        </span>
        </div>
       <div className="contact-details">
        <h6>
        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,4):""}
        {sub_value_group.sub_value_4.value}
        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.ITEMS,5):""}
         {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.ITEMS,5):""}
            </h6>
                    {sub_value_group.sub_value_5.items.map((item) => (
                    <p>
                        <Link to={item.link}>
                        {item.text}
                        </Link>
                    </p>
                    ))}
                  </div>
        </div>
        </div>
        </div>
        {/* /Contact Grid */}
    {/* Contact Grid */}
    <div className="col-lg-4 col-md-6 d-flex">
        <div className="contact-grid w-100">
        <div className="contact-content">
        <div className="contact-icon">
        <span>
        <ImageWithBasePath src="/assets/img/icons/contact-map.svg" alt="Icon" />
        </span>
        </div>
       <div className="contact-details contact-details-address">
        <h6>
        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,6):""}
        {sub_value_group.sub_value_6.value}
        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.ITEMS,7):""}
         {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.ITEMS,7):""}
            </h6>
                    {sub_value_group.sub_value_7.items.map((item) => (
                    <p>
                        <Link to={item.link}>
                        {item.text}
                        </Link>
                    </p>
                    ))}
                  </div>
</div>
        </div>
        </div>
        {/* /Contact Grid */}
    </div>
        </div>
        </div>
        {/* /Contact Bottom */}
    {/* Contact Top */}
    <div className="contact-top pt-0">
        <div className="container">
        <div className="row align-items-center">
        {/* Contact Image */}
    <div className="col-lg-6 col-md-12 d-flex">
        <div className="contact-img">
         {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.IMAGE,8):""}
    <ImageWithBasePath src={Image.get_url(sub_value_group.sub_value_8.value,Image_Format.ORIGINAL)} className="img-fluid" alt="IMG" />
        </div>
        </div>
        {/* /Contact Image */}
    {/* Contact Form */}
    <div className="col-lg-6 col-md-12 d-flex">
        <div className="team-form w-100">
        <div className="team-form-heading">
        <h3>
        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,9):""}
            {sub_value_group.sub_value_9.value}
</h3>
                  <p>
            {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,10):""}
            {sub_value_group.sub_value_10.value}

                  </p>
        </div>
        <form style={{display:'none'}} action="#">
        <div className="form-group">
        <input
        type="text"
        className="form-control"
        placeholder="Name"
        />
        </div>
        <div className="form-group">
        <input
        type="text"
        className="form-control"
        placeholder="Email"
        />
        </div>
        <div className="form-group">
        <input
        type="text"
        className="form-control"
        placeholder="Subject"
        />
        </div>
        <div className="form-group">
        <textarea
        className="form-control"
        placeholder="Your Message"
        defaultValue={""}
    />
        </div>
        <div className="form-group mb-0">
        <button type="submit" className="btn btn-primary">
        Send Message
        </button>
        </div>
        </form>
        </div>
        </div>
        {/* /Contact Form */}
    </div>
        </div>
        </div>
        {/* /Contact Top */}
    <div className="row">
    </div>
        </section>
        {/* /Contact Us */}
        <SubValue sub_value_edit={sub_value_edit} edit_mode={edit_mode} update_sub_value={update_sub_value}  />
    </>

        );
};

export default Contact;
